export var Restriction;
(function (Restriction) {
    function is(value) {
        return (value.length > 1 &&
            value.length < 5 &&
            typeof value[0] == "function" &&
            typeof value[1] == "string" &&
            (value.length == 2 || (typeof value[2] == "string" && (value.length == 3 || typeof value[3] == "string"))));
    }
    Restriction.is = is;
})(Restriction || (Restriction = {}));
//# sourceMappingURL=Restriction.js.map